export enum EShipFromStoreStatus {
  NEW = 'new',
  PACKED = 'packed',
  SENT_TO_LOGISTIC = 'sent_to_logistic',
  CANCELED = 'canceled',
  ON_HOLD = 'on_hold',
}
